module.exports = __webpack_public_path__ + "img/category-header-preview.6a7678b.png";